const cardBlocks = {
  uatp: [4, 5, 6],
  amex: [4, 6, 5],
  diners: [4, 6, 4],
  discover: [4, 4, 4, 4],
  mastercard: [4, 4, 4, 4],
  dankort: [4, 4, 4, 4],
  instapayment: [4, 4, 4, 4],
  jcb: [4, 4, 4, 4],
  maestro: [4, 4, 4, 4],
  visa: [4, 4, 4, 4],
  general: [4, 4, 4, 4],
  generalStrict: [4, 4, 4, 7]
}

const cardRe = {
  // starts with 1; 15 digits, not starts with 1800 (jcb card)
  uatp: /^(?!1800)1\d{0,14}/,

  // starts with 34/37; 15 digits
  amex: /^3[47]\d{0,13}/,

  // starts with 6011/65/644-649; 16 digits
  discover: /^(?:6011|65\d{0,2}|64[4-9]\d?)\d{0,12}/,

  // starts with 300-305/309 or 36/38/39; 14 digits
  diners: /^3(?:0([0-5]|9)|[689]\d?)\d{0,11}/,

  // starts with 51-55/22-27; 16 digits
  mastercard: /^(5[1-5]|2[2-7])\d{0,14}/,

  // starts with 5019/4175/4571; 16 digits
  dankort: /^(5019|4175|4571)\d{0,12}/,

  // starts with 637-639; 16 digits
  instapayment: /^63[7-9]\d{0,13}/,

  // starts with 2131/1800/35; 16 digits
  jcb: /^(?:2131|1800|35\d{0,2})\d{0,12}/,

  // starts with 50/56-58/6304/67; 16 digits
  maestro: /^(?:5[0678]\d{0,2}|6304|67\d{0,2})\d{0,12}/,

  // starts with 4; 16 digits
  visa: /^4\d{0,15}/
}

const getCardInfo = value => {
  if (cardRe.amex.test(value)) {
    return {
      type: 'amex',
      blocks: cardBlocks.amex
    }
  } else if (cardRe.uatp.test(value)) {
    return {
      type: 'uatp',
      blocks: cardBlocks.uatp
    }
  } else if (cardRe.diners.test(value)) {
    return {
      type: 'diners',
      blocks: cardBlocks.diners
    }
  } else if (cardRe.discover.test(value)) {
    return {
      type: 'discover',
      blocks: cardBlocks.discover
    }
  } else if (cardRe.mastercard.test(value)) {
    return {
      type: 'mastercard',
      blocks: cardBlocks.mastercard
    }
  } else if (cardRe.dankort.test(value)) {
    return {
      type: 'dankort',
      blocks: cardBlocks.dankort
    }
  } else if (cardRe.instapayment.test(value)) {
    return {
      type: 'instapayment',
      blocks: cardBlocks.instapayment
    }
  } else if (cardRe.jcb.test(value)) {
    return {
      type: 'jcb',
      blocks: cardBlocks.jcb
    }
  } else if (cardRe.maestro.test(value)) {
    return {
      type: 'maestro',
      blocks: cardBlocks.maestro
    }
  } else if (cardRe.visa.test(value)) {
    return {
      type: 'visa',
      blocks: cardBlocks.visa
    }
  } else {
    return {
      type: 'unknown',
      blocks: cardBlocks.general
    }
  }
}

const getFormattedValue = function(value, delimiter = ' ') {
  let result = ''

  if (!value) return value

  const {blocks} = getCardInfo(value)

  // no options, normal input
  if (blocks.length === 0) {
    return value
  }

  blocks.forEach((length, index) => {
    if (value.length > 0) {
      const sub = value.slice(0, length)
      const rest = value.slice(length)

      result += sub

      if (sub.length === length && index < blocks.length - 1) {
        result += delimiter
      }

      // update remaining string
      value = rest
    }
  })

  return result.trim()
}

export default getFormattedValue



// WEBPACK FOOTER //
// ./client/utils/formatCreditCard.js